import { render, staticRenderFns } from "./EditorHealthImageDialog.vue?vue&type=template&id=3211111b&scoped=true"
import script from "./EditorHealthImageDialog.vue?vue&type=script&lang=js"
export * from "./EditorHealthImageDialog.vue?vue&type=script&lang=js"
import style0 from "./EditorHealthImageDialog.vue?vue&type=style&index=0&id=3211111b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3211111b",
  null
  
)

export default component.exports